import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { LearnerService } from '../../services/learner.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { UserRoleService } from '../../services/user-role.service';

@Component({
    selector: 'app-achievement-summary-sheet',
    templateUrl: './achievement-summary-sheet.component.html',
    styleUrls: ['./achievement-summary-sheet.component.scss']
})
export class AchievementSummarySheetComponent implements OnInit {

    @Input('jobId') jobId;
    @Input('job') job;
    @Input('learnerId') learnerId;
    @Input('assesment') summarySheetEdit;
    @Input('courseComponent') courseComponent;
    achievementTrack: any;
    achievementTech: FormGroup;
    loading: boolean = false;
    trackAssessorSign: boolean;
    trackIQASign1: boolean;
    trackIQASign2: boolean;
    techIQASign1: boolean;
    techIQASign2: boolean;
    techAssessorSign: boolean;
    achievementTechEdit: any;
    achievementTrackEdit: any;
    iscourseName: any;
    isEdit: boolean = false
    jobData: any;
    isAdmin: boolean = false;
    isLearner: boolean = false;
    isIQA: boolean = false;
    isTrainer: boolean = false;

    constructor(
        public dialog: MatDialog,
        public _snackBar: MatSnackBar,
        public _learnerService: LearnerService,
        public _userRoleService: UserRoleService

    ) { }

    ngOnInit() {
        if (!this.isEdit)
            this.createForm()
        // this.iscourseName=''
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log("changes in master rail AchievementSummarySheetComponent", changes);
        if (changes.learnerId && changes.learnerId.currentValue) {
            this.learnerId = changes.learnerId.currentValue
        }

        if (changes.jobId && changes.jobId.currentValue) {
            this.jobId = changes.jobId.currentValue
        }
        if (changes.job && changes.job.currentValue) {
            this.jobData = changes.job.currentValue[0]
            this.getUserRole();
        }

        if (changes.courseComponent && changes.courseComponent.currentValue) {
            let value = changes.courseComponent.currentValue
            console.log('value here .....................', value)
            this.iscourseName = changes.courseComponent.currentValue;
        }



        if (changes.courseComponent && changes.courseComponent.currentValue) {
            let value = changes.courseComponent.currentValue
            console.log('value here .....................', value)
            this.iscourseName = changes.courseComponent.currentValue;
            // if (value == 'certificate_L2') {
            //     // isCourseHide = true
            //     this.isCourseHide = false;
            //     console.log('this data here', this.isCourseHide)
            // } else {
            //     console.log('echivement else run..........')
            //     this.isCourseHide = true
            // }

        }

        if (changes.summarySheetEdit && changes.summarySheetEdit.currentValue) {
            this.summarySheetEdit = changes.summarySheetEdit.currentValue
            console.log("value of sheet in its page done", this.summarySheetEdit);



            if (this.summarySheetEdit && this.summarySheetEdit.trackMaintenanceAchievement || this.summarySheetEdit.techCertAchievement) {
                if (this.summarySheetEdit.trackMaintenanceAchievement && this.summarySheetEdit.trackMaintenanceAchievement.assessorSign != "") {
                    this.trackAssessorSign = true
                }
                if (this.summarySheetEdit.trackMaintenanceAchievement && this.summarySheetEdit.trackMaintenanceAchievement.IQASign != "") {
                    this.trackIQASign1 = true
                }
                if (this.summarySheetEdit.trackMaintenanceAchievement && this.summarySheetEdit.trackMaintenanceAchievement.IQASign2 != "") {
                    this.trackIQASign2 = true
                }
                if (this.summarySheetEdit.techCertAchievement && this.summarySheetEdit.techCertAchievement.assessorSign != "") {
                    this.techAssessorSign = true
                }
                if (this.summarySheetEdit.techCertAchievement && this.summarySheetEdit.techCertAchievement.IQASign != "") {
                    this.techIQASign1 = true
                }
                if (this.summarySheetEdit.techCertAchievement && this.summarySheetEdit.techCertAchievement.IQASign2 != "") {
                    this.techIQASign2 = true
                }
            }

            //    this.achievementTechEdit = this.summarySheetEdit.techCertAchievement
            //    this.achievementTrackEdit = this.summarySheetEdit.trackMaintenanceAchievement
            this.isEdit = true
            this.createForm(this.summarySheetEdit)
        }
        else {
            this.createForm()
        }
    }
    getUserRole() {
        console.log("this......................", this.jobData);

        let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
        if (getRole.isAdmin) this.isAdmin = true
        else if (getRole.isLearner) this.isLearner = true
        else if (getRole.isTrainer) this.isTrainer = true
        else if (getRole.isIQA) this.isIQA = true
    }

    createForm(details?) {
        this.achievementTrack = new FormGroup({
            date101: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date101 : ''),
            date102: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date102 : ''),
            date201: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date201 : ''),
            date203: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date203 : ''),
            date204: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date204 : ''),
            date205: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date205 : ''),
            date206: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date206 : ''),
            date207: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date207 : ''),
            date208: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date208 : ''),
            date209: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date209 : ''),
            date211: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.date211 : ''),
            assessorSign: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.assessorSign : ''),
            assessorDate: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.assessorDate : ''),
            IQASign: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.IQASign : ''),
            IQADate: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.IQADate : ''),
            IQASign2: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.IQASign2 : ''),
            IQADate2: new FormControl((details && details.trackMaintenanceAchievement) ? details.trackMaintenanceAchievement.IQADate2 : ''),
        })

        this.achievementTech = new FormGroup({
            date001: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.date001 : ''),
            date002: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.date002 : ''),
            date003: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.date003 : ''),
            date004: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.date004 : ''),
            assessorSign: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.assessorSign : ''),
            assessorDate: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.assessorDate : ''),
            IQASign: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.IQASign : ''),
            IQADate: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.IQADate : ''),
            IQASign2: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.IQASign2 : ''),
            IQADate2: new FormControl((details && details.techCertAchievement) ? details.techCertAchievement.IQADate2 : ''),
        })
    }

    onChangeEvent(value, formGroup, formControl) {
        console.log("value, formControl, formGroup", value, formControl, formGroup);

        if (formGroup == 'achievementTrack')
            this.achievementTrack.get(formControl).setValue(value);

        else if (formGroup == 'achievementTech')
            this.achievementTech.get(formControl).setValue(value);

    }


    // Utility
    handleSnackBar(data) {
        this.openSnackBar(data.msg, data.button);
    }
    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 2000,
        });
    }

    openDialog(someComponent, data = {}): Observable<any> {
        console.log("OPENDIALOG", "DATA = ", data);
        const dialogRef = this.dialog.open(someComponent, {
            data, maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%'
        });
        return dialogRef.afterClosed();
    }

    checkLevel2Policy(policy) {
        let temp = this.iscourseName.includes(policy)
        if (temp) {
            return false
        } else {
            return true
        }
    }
    addSignature(formType, fomrControl) {
        if ((this.isIQA || this.isLearner) && (fomrControl == 'trackAssessorSign' || fomrControl == 'techAssessorSign')) return
        else if ((this.isTrainer || this.isLearner) && (fomrControl == 'trackIQASign1' || fomrControl == 'trackIQASign2' || fomrControl == 'techIQASign1' || fomrControl == 'techIQASign2')) return
        else {
            this.openDialog(SignaturePadComponent).subscribe((data) => {
                console.log("data of sign", data);
                if (data == undefined) return

                let sign = data

                if (formType == 'achievementTrack') {
                    if (fomrControl == 'trackAssessorSign') {
                        this.trackAssessorSign = true
                        this.achievementTrack.patchValue({
                            assessorSign: sign
                        })
                    }
                    if (fomrControl == 'trackIQASign1') {
                        this.trackIQASign1 = true
                        this.achievementTrack.patchValue({
                            IQASign: sign
                        })
                    }
                    if (fomrControl == 'trackIQASign2') {
                        this.trackIQASign2 = true
                        this.achievementTrack.patchValue({
                            IQASign2: sign
                        })
                    }
                }
                else if (formType == 'achievementTech') {
                    if (fomrControl == 'techAssessorSign') {
                        this.techAssessorSign = true
                        this.achievementTech.patchValue({
                            assessorSign: sign
                        })
                    }
                    if (fomrControl == 'techIQASign1') {
                        this.techIQASign1 = true
                        this.achievementTech.patchValue({
                            IQASign: sign
                        })
                    }
                    if (fomrControl == 'techIQASign2') {
                        this.techIQASign2 = true
                        this.achievementTech.patchValue({
                            IQASign2: sign
                        })
                    }
                }
            })
        }

    }

    saveForm() {
        console.log('save forms', this.achievementTrack.value)
        console.log('save forms', this.achievementTech.value)
        this.loading = true
        //let data = {
        //    learnerId: this.learnerId,
        //    jobId: this.jobId
        //}
        //let details = {
        //    trackMaintenance: this.trackMaintenance.value,
        //    techCert: this.techCert.value,
        //}
        let data = {
            learnerId: this.learnerId,
            jobId: this.jobId,
            version: true,
            details: {
                trackMaintenanceAchievement: this.achievementTrack.value,
                techCertAchievement: this.achievementTech.value
            }
        }
        console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
        this._learnerService.submitPolicy(data).subscribe(res => {
            console.log('Policy res', res);
            this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
            this.loading = false
        }, (err) => {
            this.loading = false
            console.log("policy not accepted", err)
        })
    }
}
